<template>
  <div :class="`chart ready-set-go md-layout-item md-size-${width} md-large-size-${width} md-medium-size-${width} md-small-size-100`">
    <div class="ready-set-go">
        <h2>{{label}}</h2>
        <div style=" max-width: 280px; margin: 0 auto;">
            <apexchart  height="300" type="radialBar" :options="chartOptions" :series="series"></apexchart>
        </div>
        <div class="spacer">&nbsp;</div>
    </div>
  </div>
</template>

<script>
  import VueApexCharts from "vue-apexcharts";

  export default {
    name: "ReadySetGo",
    computed: {},
    components: {
      apexchart: VueApexCharts
    },
    mounted() {
    },
    data() {
      let tabs = window.drupalSettings.controller.graphs.ReadySetGo.data
      return {
        label: window.drupalSettings.controller.graphs.ReadySetGo.label,
        width: window.drupalSettings.controller.graphs.ReadySetGo.width || 33,
        series: [tabs.field_ready_form, tabs.field_set_form, tabs.field_go_form],
        chartOptions: {
          plotOptions: {
            radialBar: {
              offsetY: 0,
              offsetX: 0,
              startAngle: 0,
              endAngle: 270,
              hollow: {
                margin: 5,
                size: "30%",
                background: "transparent",
                image: undefined
              },
              dataLabels: {
                name: {
                  show: false
                },
                value: {
                  show: false
                }
              },
              track: {
                show: true,
                background: '#333',
                opacity: 0.2,
                startAngle: 0,
                endAngle: 270,
              }
            }
          },

          colors: ['#457b9d', '#83d9f3', '#f68821'],
          labels: ["Ready", "Set", "Go"],
          legend: {
            show: true,
            floating: true,
            fontSize: "14px",
            position: "left",
            fontFamily: "Source Sans Pro",
            labels: {
              useSeriesColors: false,
              colors: ['#3c3c3c'],
            },
            //width: 150,
            horizontalAlign: 'left',
            //offsetX: 100,
            //offsetY: 110,
            formatter: function (seriesName, opts) {
              return seriesName + ":  " + opts.w.globals.series[opts.seriesIndex] + '%';
            },
            itemMargin: {
              horizontal: 1
            }
          },
          stroke: {
            lineCap: "round"
          },
          states: {
            hover: {
              filter: {
                type: 'lighten',
                value: 0,
              }
            },

          },
          responsive: [
            {
              breakpoint: 325,
              options: {
                legend: {
                  offsetX: -20,
                  offsetY: -30,
                },
              }
            },
            {
              breakpoint: 380,
              options: {
                legend: {
                  offsetX: 0,
                  offsetY: 80,
                },
              }
            },
            {
              breakpoint: 480,
              options: {
                legend: {
                  offsetX: 0,
                  offsetY: 120,
                },
              }
            },
            {
              breakpoint: 770,
              options: {
                legend: {
                  offsetX: 0,
                  offsetY: 130,
                },
              }
            },
            {
              breakpoint: 1000,
              options: {
                legend: {
                  offsetX: 270,
                  offsetY: 130,
                },
              }
            },
            {
              breakpoint: 1030,
              options: {
                plotOptions: {
                  radialBar: {
                    //size: 60,
                  }
                },
                legend: {
                  offsetX: 0,
                  offsetY: 120,
                },
              }
            },
            {
              breakpoint: 1370,
              options: {
                legend: {
                  offsetX: -20,
                  offsetY: 120,
                },
              }
            },
            {
              breakpoint: 1450,
              options: {
                plotOptions: {
                  radialBar: {
                    //height: 300,
                  }
                }
              }
            }

          ],
        },
      };
    },

    methods: {}
  };
</script>
<style lang="scss">
    .ready-set-go {
        .apexcharts-legend {
          top: 45px !important;
        }

        .apexcharts-graphical {
            //transform: translate(60px, 0px);
            @media only screen and (max-width: 1025px)  {
                //transform: translate(105px, 90px);
            }

            .apexcharts-legend-text {
                font-family: "Source Sans Pro" !important;
                font-size: 14px !important;
            }
        }
    }
</style>
